import axiosLib from "axios";

const axios = ({ method = "get", url, data = {}, headers = {}, signal }) => {
  return axiosLib({
    method,
    url,
    data,
    headers,
    signal,
  });
};

export default axios;
